/* global I18n */
import FaIcon from "components/fa_icon"
import React, {useState} from "react"
import Learnables from "./learnables"

function QuizContentInfo({learnables, is_truncated = false}) {
  const [show_all, set_show_all] = useState(!is_truncated)
  const six_learnables = learnables.slice(0, 6)
  const collapsed_learnables_count = learnables.length - 6

  function handle_show_all() {
    set_show_all(!show_all)
  }

  return (
    <div className="embedded-quiz-info">
      <div className="container">
        <p className="title">
          {I18n.t("js.embedded_quiz.content_info.title")}
        </p>
        <div className="learnables">
          {!show_all && six_learnables.map((learnable) => (
            <Learnables key={learnable.id} learnable={learnable}/>))}
          {show_all && learnables.map((learnable) => (
            <Learnables key={learnable.id} learnable={learnable}/>))}
        </div>
        {learnables.length > 6 && !show_all && (
          <button onClick={handle_show_all} className="btn btn-link btn-block">
            {I18n.t("js.embedded_quiz.content_info.plus_n_more", {
              count: collapsed_learnables_count
            })}
            <FaIcon name={"fa-arrow-right"}/>
          </button>)}
      </div>
    </div>
  )
}

export default QuizContentInfo
